import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo_e.png";
import navIcon1 from "../assets/img/linkedin-mark-white.svg";
import navIcon2 from "../assets/img/github-mark-white.svg";
import navIcon3 from "../assets/img/instagram-mark-white.svg";
import navIcon4 from "../assets/img/gmail-mark-white.svg";

export const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <Row className="align-items-center">
                    <Col size={12} sm={6}>
                        <img src={logo} alt="Logo" />
                    </Col>
                    <Col size={12} sm={6} className="text-center text-sm-end">
                        <div className="social-icon">
                            <a href="https://www.linkedin.com/in/enoch-tan-jeng-sen-563a89245/"><img src={navIcon1} alt="Icon" /></a>
                            <a href="https://github.com/En0chTan"><img src={navIcon2} alt="Icon" /></a>
                            <a href="https://www.instagram.com/et_4it/"><img src={navIcon3} alt="Icon" /></a>
                            <a href="mailto:enochtan.js.work@gmail.com"><img src={navIcon4} alt="Icon" /></a>

                        </div>
                        <p>Copyright 2025-2026. All Rights Reserved</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}